import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    ShareButtons
} from 'react-share';

const {
    FacebookShareButton,
    TwitterShareButton
} = ShareButtons;

class Profile extends Component {
    render () {
        return (
            <div className='view-background profile-bg'>
                <div className='perfil'>
                    <div className='header'>
                        <div>
                            <p>Convidando amigos vc ganha mais pontos quando eles se cadastrarem</p>
                        </div>
                        <div>
                            <div style={{height: 50, width: 100, backgroundColor: '#fff', margin: 20}}>
                                <FacebookShareButton style={{height: 50, width: 100}} url={`https://ufjf-test.herokuapp.com/public/profile/${this.props.userId}`} />
                            </div>
                            <div style={{height: 50, width: 100, backgroundColor: '#fff', margin: 20}}>
                                <TwitterShareButton style={{height: 50, width: 100}} url={`https://ufjf-test.herokuapp.com/public/profile/${this.props.userId}`} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({

});
const mapStateToProps = (state) => ({
    userId: state.user.user._id
});
export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/views/UserViews/shareView.js